import classbazzar from "../../assets/image/Projects/classbazaar.png"
import woodshala from "../../assets/image/Projects/woodshala.png"
import woodshalaApp from "../../assets/image/Projects/woodshalaApp.png"
import portfolio from "../../assets/image/Projects/portfolio.png"
import Drytech from "../../assets/image/Projects/dryTech.jpg"
import bitwit from "../../assets/image/Projects/bitwit.jpeg"
import dcs from "../../assets/image/Projects/dcs.png"
import parking from "../../assets/image/Projects/parking.png"

let mern_projects = [
    {
        title : "Classbazzar",
        img : classbazzar,
        description : "Classbazzar, is the online course selling website. Partner with provider such as Udemy, Coursera, Future Learn and edX.",
        link : "https://classbazaar.com/",
    },
    {
        title : "Woodshala",
        img : woodshala,
        description : "Woodshala, is the online furniture selling website. This was my first e-commerce project ",
        link : "https://drive.google.com/drive/folders/1coUjiqeKFKifNg5PtooJ8zT2wdo5FK9b?usp=sharing",
    },
    {
        title : "Protfolio",
        img : portfolio,
        description : "This is my portfolio app, to display all the information about me and my work.",
        link : "https://classbazaar.com/",
    },
    {
        title : "Drytech",
        img : Drytech,
        description : "Drytech is leading powder and deytech supplement company.",
        link : "https://drytechlive.onrender.com/",
    }
]
let static_projects = [
    {
        title : "BITWIT",
        img : bitwit,
        description : "BITWIT, this project is for display the work and experties of BITWIT Technologies.",
        link : "https://bitwit-tech.netlify.app/",
    },
    {
        title : "DCS",
        img : dcs,
        description : "DCS, abither static site project to market the DCS consultancy services and experties.",
        link : "https://dcsconsulting.co/",
    }
]
let android_projects = [
    {
        title : "TNT",
        img : parking,
        description : "TNT, Traffic No Traffic App provide parking at marked destination. This app use Google APIs to track your vehicle.",
        link : "https://drive.google.com/drive/folders/1_-ShC3pWXFymw5jFjXLG3SIA41ayc00d?usp=sharing",
    },
    {
        title : "Woodshala App",
        img : woodshalaApp,
        description : "Woodshala App, this is my e-commerce project with Shopify APIs for backend.",
        link : "https://drive.google.com/drive/folders/1Cx0zoju5L59PzWvQX88wviQ4-F8Pks2_?usp=sharing",
    }
]


export {mern_projects,static_projects, android_projects}